import {
  addItemToCollection,
  updateItemInCollection,
} from "directus/src/operations";

export async function createDedicatedConfig({ jobId, values }) {
  try {
    const query = {
      fields: ["id", "cost", "currency", "paid_leaves", "project.project_id"],
    };

    const response = await updateItemInCollection(
      "jobs",
      jobId,
      {
        dedicated_job_config: values,
      },
      query
    );
    return response;
  } catch (error) {
    console.error("Error creating dedicated config:", error);
    throw error;
  }
}

export async function updateDedicatedConfig({ id, values }) {
  try {
    const query = {
      fields: ["id", "cost", "currency", "paid_leaves"],
    };

    const response = await updateItemInCollection(
      "dedicated_job_config",
      id,
      values,
      query
    );
    return response;
  } catch (error) {
    console.error("Error updating dedicated config:", error);
    throw error;
  }
}
